import React from "react";
import Reveal from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs as Q } from "../mock";

const FAQ = () => {
  return (
    <section className="bg-[#ececec] py-24 md:py-32 px-5">
      <div className="max-w-[820px] mx-auto">
        <Reveal>
          <p className="text-[#8a8a8a] text-sm mb-3 text-center">{Q.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-4xl md:text-6xl text-center text-[#141414]">{Q.title}</h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-center text-[#5f5f5f] mt-4 mb-12">{Q.subtitle}</p>
        </Reveal>

        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="space-y-3">
            {Q.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white rounded-2xl border-none px-6"
              >
                <AccordionTrigger className="font-cal text-lg md:text-xl text-[#141414] hover:no-underline py-5 text-left">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5f5f5f] leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
